module.exports = __webpack_public_path__ + "img/Hybrid-D-8.ab8d2d13.jpg";